import { PAGE_PATHS } from "./constants";
import { stripViPrefix } from "./localePaths";

/** Normalize URL path for route matching (trailing slash, empty). */
export function normalizePathname(pathname) {
  let p = pathname && String(pathname).trim() ? String(pathname).trim() : "/";
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p || "/";
}

export function pageFromPath(pathname) {
  const path = stripViPrefix(pathname);
  if (path === "/sign-up") return "login";
  const match = Object.entries(PAGE_PATHS).find(([, routePath]) => routePath === path);
  return match ? match[0] : "landing";
}
